import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { DataService, DateService, HelperService, HTTPService } from 'app/services';
import { debounce } from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss'],
})
export class GlobalSearchComponent implements OnInit, OnDestroy {
  @Input() subId: string = '';
  _globalSearch = debounce(() => this.dataService.updateSearchEvent(this.query), 600);
  results: any[] = [];
  query: string = '';
  currentTime: any = '';
  isLoading: boolean = false;
  isLoadingMore: boolean = false;
  isROPrioritiesEnabled: boolean = false;
  defaultPriority: any = {};
  dataServiceSubscription: Subscription;
  totalPages: number = 0;
  pageIndex: number = 0;
  limit: number = 3;
  totalRecords: number = 0;
  isEnhancedGlobalSearchEnabled: boolean = false;
  globalSearchIncludeArchivedOrders: boolean = false;
  isMyFleetCenterEnabled: boolean = false;

  constructor(private httpService: HTTPService, private helperService: HelperService, private dataService: DataService, private dateService: DateService) { }

  ngOnInit() {
    this.dataServiceSubscription = this.dataService.getData().subscribe(({ data }) => {
      if (data) {
        if (data.key === 'company-appdata-updated') {
          this.isROPrioritiesEnabled = this.dataService.isROPrioritiesEnabled;
          this.isEnhancedGlobalSearchEnabled = this.dataService.isEnhancedGlobalSearchEnabled;
          this.globalSearchIncludeArchivedOrders = this.dataService.globalSearchIncludeArchivedOrders;
          this.isMyFleetCenterEnabled = this.dataService.isMyFleetCenterEnabled;

          this.dataServiceSubscription.unsubscribe();
        }
      }
    });
    this.isROPrioritiesEnabled = this.dataService.isROPrioritiesEnabled;
    this.isEnhancedGlobalSearchEnabled = this.dataService.isEnhancedGlobalSearchEnabled;
    this.globalSearchIncludeArchivedOrders = this.dataService.globalSearchIncludeArchivedOrders;
    this.isMyFleetCenterEnabled = this.dataService.isMyFleetCenterEnabled;
  }

  resetSearch(event) {
    if (this.isEnhancedGlobalSearchEnabled && event) this.query = '';
  }

  ngOnDestroy() {
    if (this.dataServiceSubscription) {
      this.dataServiceSubscription.unsubscribe();
    }
  }

  handleSelect(customer: any) {
    this.dataService.sendData(this.dataService.typeSidebar('customer', customer._id, customer.fullName, { _id: customer._id }));
  }

  handleClear() {
    this.isLoading = false;
    this.results = [];
    this.query = '';
  }

  onSearchEnter() {
    if (this.results.length) {
      this.query = '';
      this.results = [];
    }
  }

  handleSearch(query: string) {
    this.query = query;
    const config = {
      limit: this.limit,
      skip: this.pageIndex * this.limit,
    };

    if (!this.pageIndex) {
      this.isLoading = true;
    } else {
      this.isLoadingMore = true;
    }
    this.httpService
      .globalSearch(query.replace(/[^a-zA-Z0-9@.+_ ]/g, ''), config)
      .then(
        (results: any) => {
          if (results.data && results.data.metaData && results.data.metaData.totalRecords) {
            this.totalPages = Math.ceil(results.data.metaData.totalRecords / this.limit);
          }
          this.totalRecords = results.data.metaData.totalRecords;

          if (results && results.data && results.data.records) {
            this.currentTime = this.dateService.getCurrentDateTimeTz(results.serverTime);
            this.defaultPriority = results.mediumTag;
            this.currentTime = new Date(this.currentTime).setHours(0, 0, 0, 0);

            results.data.records.forEach((result: any) => {
              result.appointments = result.appointments.filter(({ start }) => new Date(start).getTime() > this.currentTime);
            });

            if (!this.pageIndex) {
              this.results = results.data.records;
            } else {
              this.results = [...this.results, ...results.data.records];
            }

            this.isLoading = false;
          }
        },
        (err) => {
          this.isLoading = false;
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isLoadingMore = false;
      });
  }

  handleShowMore(event: Event) {
    event.stopPropagation();
    event.preventDefault();

    this.pageIndex++;
    this.handleSearch(this.query);
  }

  handleChange(event) {
    this.query = event;
    // if (this.query.length >= 2) {
    this._globalSearch();
    // this.dataService.updateSearchEvent(this.query);
    // }
  }
}
